import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { closeModalAction } from '../../../actions/modal';
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../common/Form';
import { MilestoneTable } from './AddMileStone';
import { actualValueForDropdown } from '../../../utils/common';

export const formTableName = 'tasks';
const formName = "checklistFrom";

const inputTypeOptions = [
    { value: 'FILE', label: 'File Upload' },
    { value: 'TEXT', label: 'Text Input' },
    { value: 'SELECT', label: 'Single Select' },
    { value: 'MULTI_SELECT', label: 'Multi Select' }
];

export default function CheckListToProject({ setFormValuesMS, name, onCancel }) {
    const { formButtonLoading } = useSelector((state) => state.loading);
    const { defaultMilestones } = useSelector((state) => state.admin)
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(true)

    const defaultValues = {
        [formTableName]: [{ id: `${Math.random()}`, options: [] }],
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    const onSubmit = (formValues) => {
        const formValuesWithOptions = {
            ...formValues,
            [formTableName]: formValues[formTableName].map((item, index) => {
                let options = [];
                if (item.options && item.options.length > 0) {
                    options = item.options.map((elem) => ({ label: actualValueForDropdown(elem), value: actualValueForDropdown(elem) }));
                }
                return ({
                    ...item,
                    options
                })
            }),
            type: name,
            defaultData: defaultMilestones?.find(task => task.type === name)
        };
        setFormValuesMS(formValuesWithOptions);
        dispatch(closeModalAction())
    };

    return (
        <div className="bg-white rounded-lg overflow-auto max-h-[60vh]">
            <Form
                className="w-full"
                onSubmit={onSubmit}
                isLoading={formButtonLoading[formName]}
                submitButtonText="Save Milestones"
                showSubmit
                // isSubmitDisabled={disabled}
                submitContainerClassName="flex gap-3 justify-end p-4 border-t"
                methods={methods}
                onCancel={() => {
                    dispatch(closeModalAction())
                    onCancel()
                }}
            >
                <MilestoneTable name={formTableName} selectedMilestone={name} />
            </Form>
        </div>
    )
}
